import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const verticalWrapper = css`
  position: relative;
`

export const vercticalContent = css`
  & > *:not(:last-child) {
    margin-inline-end: ${spacing(1)};
  }
`
export const vertical = css`
  inline-size: ${spacing(19.75)}; // 158px
  block-size: ${spacing(13.5)}; // 108px
`
